module.exports = __webpack_public_path__ + "assets/img/新疆.5375d3f0.png";